module.exports = __webpack_public_path__ + "fonts/opensans-italic.a631cb7d.woff2";